import { FormikHelpers } from "formik";
import { PaymentMethod } from "components/Payment/paymentTypes";

export type Flow = "dummy-account" | "full-account";
export type FormAction = "createAccount" | "createDummyAccount" | "login";
export type FormActionDummyAccount = "createDummyAccount" | "login";
export type FormActionFullAccount = "createAccount" | "login";

export enum AuthKey {
  EMAIL = "email",
  LOGIN = "login",
  MAILING_LIST = "mailingList",
  PASSWORD = "password",
  TERMS = "termsPolicy",
}

export type AuthKeyEnumValue = `${AuthKey}`;
export type AuthValues = {
  [AuthKey.EMAIL]: string;
  [AuthKey.LOGIN]: string;
  [AuthKey.MAILING_LIST]: boolean;
  [AuthKey.PASSWORD]: string;
  [AuthKey.TERMS]: boolean;
};
export type AuthValuesOptionals = {
  [P in keyof AuthValues]?: AuthValues[P];
};
export type AuthSubmit = (
  values: AuthValues,
  formikHelpers: FormikHelpers<AuthValues>
) => void;

export type SocialLoginSuccess = () => void;

export enum CouponKey {
  COUPON = "coupon",
}

export type CouponKeyEnumValue = `${CouponKey}`;
export type CouponValues = {
  [CouponKey.COUPON]: string;
};
export type CouponSubmit = (
  values: CouponValues,
  formikHelpers: FormikHelpers<CouponValues>
) => void;

export enum PaymentMethodKey {
  PAYMENT_METHOD = "paymentMethod",
}
export type PaymentMethodKeyEnumValue = `${PaymentMethodKey}`;
export type PaymentMethodValue = PaymentMethod;
export type PaymentMethodValues = {
  [PaymentMethodKey.PAYMENT_METHOD]: PaymentMethodValue;
};
export type PaymentMethodValuesPartial = Partial<PaymentMethodValues>;
export type PaymentMethodSubmit = (
  values: PaymentMethodValues,
  formikHelpers: FormikHelpers<PaymentMethodValues>
) => void;

export enum LegalEnrollmentKey {
  LEGAL_ENROLLMENT = "legalEnrollment",
}
export type LegalEnrollmentKeyEnumValue = `${LegalEnrollmentKey}`;
export type LegalEnrollmentValues = {
  [LegalEnrollmentKey.LEGAL_ENROLLMENT]: boolean;
};
export type LegalEnrollmentValuesPartial = Partial<LegalEnrollmentValues>;
export type LegalEnrollmentSubmit = (
  values: LegalEnrollmentValues,
  formikHelpers: FormikHelpers<LegalEnrollmentValues>
) => void;
